import React, { Fragment } from 'react'
import { Breadcrumb, Card, Col, Collapse, Icon, Layout, Popconfirm, Row, Spin, Tabs, Tooltip } from 'antd'
import { get } from 'lodash'
import style from './style.css'
import Overview from '../Form/Overview'
import AccountBalanceLines
  from '../../../../../components/Sales/Client/Contract/ViewContract/AccountBalanceLines/AccountBalanceLines'
import { idMaker, numVal, strVal } from '../../../../../modules/Utils'
import KeyTerms from '../Form/KeyTerms'
import Payment from '../Form/Payment'
import Communication from '../Form/Communication'
import Rates from '../Form/Rates'
import Status from '../../../../../elements/Status'
import DocumentsCont from '../../../../Common/Documents/DocumentsCont'
import OrderLineList from './OrderLines/OrderLineList'
import OrderLineModal from './OrderLines/OrderLineModal'
import TerminationModal from './TerminationModal'
import StateSelect from '../../../../../elements/Select/StateSelect'
import InvoiceModalCont from '../../../../../components/Common/InvoiceModal/InvoiceModalCont'
import OrdersCont from '../../../../../components/Sales/Orders/OrdersCont'
import RefreshButton from '../../../../../elements/Buttons/RefreshButton'
import Amount from '../../../../../components/Common/Amount'
import ReceiptsCont from '../../../../../components/Sales/Payments/Receipts/ReceiptsCont'
import InvoicesCont from '../../../../../components/Sales/Invoices/InvoicesCont'
import AddBudgetCont from '../../../../../components/Common/Budgets/BudgetCont'
import { withRouter } from 'react-router-dom'
import useTitle from '../../../../../elements/Hooks/useTitle'
import DeliveryAddresses from '../Form/DeliveryAddresses'

const { Panel } = Collapse

const { Content } = Layout
const { TabPane } = Tabs
const ids = idMaker()

function ViewContract (props) {
  const {
    member,
    client,
    fetching,
    contract,
    actions,
    subtotal,
    updatingState,
    updatingBillingState,
    productsUrl,
    handleOps,
    fetch,
    fetchLines,
    clientKey,
    updateContractState,
    updateBillingState,
    fetchingLines,
    CustomerOrderSelect,
  } = props
  useTitle(`View ${contract.code} Contract`)
  const isUpdatable = actions.find(a => a.key === 'update') && true
  const Operations = ({ contract, ...rest }) => {
    const ops = actions.map(a => (
      <span>
        <Popconfirm
          placement="left"
          title={`Are you sure to ${a.value}?`}
          onConfirm={() => handleOps(a.key, contract)}
          okText="Yes"
          cancelText="No">
          <a>{a.value}</a>
        </Popconfirm>
      </span>
    ))
    return (
      <div {...rest}>
        {ops.length > 0
          ? ops.reduce((prev, curr) => [prev, <span className="ant-divider"/>, curr])
          : []}
      </div>
    )
  }
  return (
    <Fragment>
      <Card loading={fetching}>
        <Row className={style.pageHeader}>
          <RefreshButton onClick={fetch}/>
          <Breadcrumb style={{ marginBottom: 10 }}>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Sales</Breadcrumb.Item>
            <Breadcrumb.Item href="#/clients/list">Clients List</Breadcrumb.Item>
            <Breadcrumb.Item href={`#/clients/${clientKey}/#contracts`}>
              {member.fn}
            </Breadcrumb.Item>
            <Breadcrumb.Item>{contract.code}</Breadcrumb.Item>
          </Breadcrumb>
          <Col span={9}>
            <h3 className={style.title}>
              <h2 className={'icon-text-header'}>
                <Icon
                  type="barcode"
                  style={{
                    marginRight: '5px',
                    color: '#08c',
                  }}
                />
                <Tooltip title="Contract  Code">{strVal(contract, 'code')}</Tooltip>
              </h2>
              <Status value={strVal(contract, 'status')}/>
              <Row style={{ marginTop: 10 }}>
                <Col span={6}>Service State:</Col>
                <Col span={14}>
                  <StateSelect
                    value={get(contract, 'state')}
                    onChange={updateContractState}
                    disabled={updatingState}
                  />
                </Col>
                <Col span={1}>
                  <Spin style={{ marginLeft: 10 }} spinning={updatingState}/>
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col span={6}>Billing State:</Col>
                <Col span={14}>
                  <StateSelect
                    value={get(contract, 'billingState')}
                    onChange={updateBillingState}
                    disabled={updatingBillingState}
                  />
                </Col>
                <Col span={1}>
                  <Spin style={{ marginLeft: 10 }} spinning={updatingBillingState}/>
                </Col>
              </Row>
              <Operations
                style={{ marginTop: '10px' }}
                contract={contract}
                status={strVal(contract, 'status')}
              />
            </h3>
            <p className={style.paragraph}>{member.fn} Account Details</p>
          </Col>
          <Col span={5}>
            <Amount
              title={'Orders'}
              data={[{ name: 'Net', amount: numVal(subtotal, 'orders.net') }]}
              currency={strVal(contract, 'pay.currency')}
            />
          </Col>
          <Col span={5}>
            <Amount
              title={'Invoices'}
              data={[
                { name: 'Net', amount: numVal(subtotal, 'invoices.net') },
                { name: 'Tax', amount: numVal(subtotal, 'invoices.tax') },
                { name: 'Gross', amount: numVal(subtotal, 'invoices.gross') },
              ]}
              currency={strVal(contract, 'pay.currency')}
            />
          </Col>
          <Col span={5}>
            <Amount
              title={'Receipts'}
              data={[
                {
                  name: 'Paid Amount',
                  amount: numVal(subtotal, 'receipts.net'),
                },
              ]}
              currency={strVal(contract, 'pay.currency')}
            />
          </Col>
        </Row>
      </Card>
      <Row style={{ paddingTop: '10px' }}>
        <Card loading={fetching} style={{ minHeight: '542px' }}>
          <Row style={{ paddingTop: '10px' }}>
            <TerminationModal {...props} />
            <InvoiceModalCont key={ids.next().value} orderType={contract.type} {...props} />
            <Tabs
              defaultActiveKey={get(props, 'location.hash') || '#details'}
              onChange={key => props.history.push(key)}>
              <TabPane
                tab={
                  <span>
                    <Icon type="info-circle"/>
                    Details
                  </span>
                }
                key="#details">
                <Collapse bordered={false} defaultActiveKey={['1']}>
                  <Panel header={<h3>Account Overview</h3>} key="1">
                    <Overview
                      member={member}
                      client={client}
                      contract={contract}
                      CustomerOrderSelect={CustomerOrderSelect}
                    />
                  </Panel>
                  <Panel header={<h3>Key Terms</h3>} key="2">
                    <KeyTerms client={client} contract={contract}/>
                  </Panel>
                  <Panel header={<h3> Billing & Payment</h3>} key="4">
                    <Payment client={client} contract={contract}/>
                  </Panel>
                  <Panel header={<h3>Communication</h3>} key="5">
                    <Communication client={client} member={member} contract={contract}/>
                  </Panel>
                  <Panel header={<h3>Rates</h3>} key="rates">
                    <Rates client={client} type={'view'} contract={contract}/>
                  </Panel>
                  <Panel header={<h3>Default Delivery/Service Locations</h3>} key="delivery">
                    <DeliveryAddresses client={client} contract={contract}/>
                  </Panel>
                </Collapse>
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <Icon type="bars"/>
                    Order Lines
                  </span>
                }
                key="#lines">
                <OrderLineModal isUpdatable={isUpdatable} {...props} />
                <OrderLineList
                  isUpdatable={isUpdatable}
                  {...props}
                  hide={{ create: !isUpdatable }}
                  url={productsUrl}
                  fetching={fetchingLines}
                  fetch={fetchLines}
                />
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <Icon type="credit-card"/>
                    Budget
                  </span>
                }
                key="#budgets">
                <AddBudgetCont loading={fetching} owner={contract}/>
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <Icon type="credit-card"/>
                    Balance Lines
                  </span>
                }
                key="#AccountBalanceLines">
                <AccountBalanceLines contract={contract}/>
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <Icon type="file-text"/>
                    Orders
                  </span>
                }
                key="#sales-orders">
                <OrdersCont contract={get(contract, '_id')}/>
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <Icon type="file-text"/>
                    Invoices
                  </span>
                }
                key="#invoices">
                <InvoicesCont contract={contract} type={'list'}/>
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <Icon type="file-text"/>
                    Receipts
                  </span>
                }
                key="#receipts">
                <ReceiptsCont contract={contract}/>
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <Icon type="file-text"/>
                    Statements
                  </span>
                }
                disabled={true}
                key="#statements"
              />
              <TabPane
                tab={
                  <span>
                    <Icon type="folder-open"/>
                    Documents
                  </span>
                }
                key="#docs">
                <DocumentsCont owner={contract}/>
              </TabPane>
            </Tabs>
          </Row>
        </Card>
      </Row>
    </Fragment>
  )
}

export default withRouter(ViewContract)
